import { Refresh } from "@mui/icons-material";
import { Stack, SxProps, Typography } from "@mui/material";
import { getTimeString } from "gardenspadejs/dist/dateHelpers";
import { useState } from "react";
import { isMobile } from "react-device-detect";
import { useTranslation } from "react-i18next";

import { IconButton } from "@/components/deprecated-mui/icon-button";
import { useTimer } from "@/hooks/use-timer";
import { NAMESPACES } from "@/i18n/constants";

const ANIMATION_DURATION = 500;

interface LastUpdatedProps {
    lastUpdatedTime: Date;
    onClickRefresh?: () => void;
    sx?: SxProps;
}

export function LastUpdated({ lastUpdatedTime, onClickRefresh, sx }: LastUpdatedProps) {
    const [refresh, setRefresh] = useState(false);
    const { t } = useTranslation(NAMESPACES.FEATURES.CARDS, {
        keyPrefix: "deprecated.info-cards.device-info-card.status-timers",
    });
    const { elapsedTimeString } = useTimer({
        startTime: lastUpdatedTime.valueOf(),
        timerTickInterval: 1000,
    });
    const handleRefresh = () => {
        // Handle spin animation
        setRefresh(true);
        setTimeout(() => {
            setRefresh(false);
        }, ANIMATION_DURATION);

        onClickRefresh?.();
    };

    return (
        <Stack
            direction={isMobile ? "column-reverse" : "row"}
            alignItems={isMobile ? "flex-start" : "center"}
            sx={{ ...sx }}
        >
            <Typography variant={"caption"}>
                Last Updated: {getTimeString(new Date(lastUpdatedTime), "hh:mm:ss nn")}
            </Typography>
            <Stack direction={"row"} alignItems={"center"}>
                <Typography variant={"caption"} sx={{ marginLeft: isMobile ? "0px" : "4px" }}>
                    {t("refreshed", { timeAgo: elapsedTimeString })}
                </Typography>
                <IconButton
                    icon={<Refresh sx={{ fontSize: "16px" }} />}
                    title={"Refresh"}
                    onClick={handleRefresh}
                    sx={{
                        padding: "4px",
                        "&.spin": {
                            animation: `spin ${ANIMATION_DURATION}ms 1`,
                        },
                        "@keyframes spin": {
                            "0%": {
                                transform: "rotate(0deg)",
                            },
                            "100%": {
                                transform: "rotate(360deg)",
                            },
                        },
                    }}
                    className={refresh ? "spin" : ""}
                />
            </Stack>
        </Stack>
    );
}
